import React from 'react';
import "../../styles/home/quick-links.css";
import { Link } from 'react-router-dom';

const QuickLinks = () => {
    return (
        <div className="quick-links">
            <h1 className="my-heading text-center">Quick Links</h1>
            <div className="container new-classs">
                <div className="boxes">
                    <div className="box">
                        <Link to={"/research"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Research</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sahityik-sanskritik-parishad"}>
                            <i className="fas fa-university" />
                            <p>
                                Sahityik Sanskritik <br /> Parishad
                            </p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://forms.ccsuforms.in/Alumni"} target="blank">
                            <i className="fa fa-graduation-cap" aria-hidden="true" />
                            <p>Alumni</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://ccsuniversityhostel.com/"} target="blank">
                            <i className="fa-solid fa-hotel" />
                            <p>Hostel</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/online-payment"}>
                            <i className="fas fa-money-check-alt" />
                            <p>Online Fee Payment</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/colleges"}>
                            <i className="fas fa-university" />
                            <p>List of Colleges</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://forms.ccsuresults.com/exams/teacher/"} target="_blank">
                            <i className="fas fa-chalkboard-teacher" />
                            <p>Teacher Registration</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/syllabus"}>
                            <i className="fas fa-book" />
                            <p>Syllabus</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/activities"}>
                            <i className="fas fa-trophy" />
                            <p>Activities</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://ccsuniversity.samarth.edu.in"} target="_blank">
                            <i className="fas fa-university" />
                            <p>Samarth login for Students</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sports-calendar"}>
                            <i className="fas fa-calendar" />
                            <p>Sports Calendar</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/media-report"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Media Report</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/gallery"}>
                            <i className="fas fa-camera-retro" />
                            <p>Photo Gallery</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/regular-courses"}>
                            <i className="fas fa-address-book" />
                            <p>Courses</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/enquiry-numbers"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Enquiry Numbers</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://henoc.upsdc.gov.in/"} target="_blank">
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Affiliation</p>
                        </Link>
                    </div>


                    {/* repeated */}

                    <div className="box">
                        <Link to={"/research"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Research</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sahityik-sanskritik-parishad"}>
                            <i className="fas fa-university" />
                            <p>
                                Sahityik Sanskritik <br /> Parishad
                            </p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://forms.ccsuforms.in/Alumni"} target="blank">
                            <i className="fa fa-graduation-cap" aria-hidden="true" />
                            <p>Alumni</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://ccsuniversityhostel.com/"} target="blank">
                            <i className="fa-solid fa-hotel" />
                            <p>Hostel</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/online-payment"}>
                            <i className="fas fa-money-check-alt" />
                            <p>Online Fee Payment</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/colleges"}>
                            <i className="fas fa-university" />
                            <p>List of Colleges</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://forms.ccsuresults.com/exams/teacher/"} target="_blank">
                            <i className="fas fa-chalkboard-teacher" />
                            <p>Teacher Registration</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/syllabus"}>
                            <i className="fas fa-book" />
                            <p>Syllabus</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/activities"}>
                            <i className="fas fa-trophy" />
                            <p>Activities</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://ccsuniversity.samarth.edu.in"} target="_blank">
                            <i className="fas fa-university" />
                            <p>Samarth login for Students</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sports-calendar"}>
                            <i className="fas fa-calendar" />
                            <p>Sports Calendar</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/media-report"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Media Report</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/gallery"}>
                            <i className="fas fa-camera-retro" />
                            <p>Photo Gallery</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/regular-courses"}>
                            <i className="fas fa-address-book" />
                            <p>Courses</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/enquiry-numbers"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Enquiry Numbers</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://henoc.upsdc.gov.in/"} target="_blank">
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Affiliation</p>
                        </Link>
                    </div>

                    <div className="box">
                        <Link to={"/research"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Research</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sahityik-sanskritik-parishad"}>
                            <i className="fas fa-university" />
                            <p>
                                Sahityik Sanskritik <br /> Parishad
                            </p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://forms.ccsuforms.in/Alumni"} target="blank">
                            <i className="fa fa-graduation-cap" aria-hidden="true" />
                            <p>Alumni</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://ccsuniversityhostel.com/"} target="blank">
                            <i className="fa-solid fa-hotel" />
                            <p>Hostel</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/online-payment"}>
                            <i className="fas fa-money-check-alt" />
                            <p>Online Fee Payment</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/colleges"}>
                            <i className="fas fa-university" />
                            <p>List of Colleges</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"http://forms.ccsuresults.com/exams/teacher/"} target="_blank">
                            <i className="fas fa-chalkboard-teacher" />
                            <p>Teacher Registration</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/syllabus"}>
                            <i className="fas fa-book" />
                            <p>Syllabus</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/activities"}>
                            <i className="fas fa-trophy" />
                            <p>Activities</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://ccsuniversity.samarth.edu.in"} target="_blank">
                            <i className="fas fa-university" />
                            <p>Samarth login for Students</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/sports-calendar"}>
                            <i className="fas fa-calendar" />
                            <p>Sports Calendar</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/media-report"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Media Report</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/gallery"}>
                            <i className="fas fa-camera-retro" />
                            <p>Photo Gallery</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/regular-courses"}>
                            <i className="fas fa-address-book" />
                            <p>Courses</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"/enquiry-numbers"}>
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Enquiry Numbers</p>
                        </Link>
                    </div>
                    <div className="box">
                        <Link to={"https://henoc.upsdc.gov.in/"} target="_blank">
                            <i className="fa-solid fa-magnifying-glass" />
                            <p>Affiliation</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default QuickLinks;